import { Icon } from '@project44/manifest-ui-deprecated';
import { designTokens as dt } from '@project44/manifest-ds';

export const OrderPlacedIcon = ({
  fillColor = `${dt.colorPaletteGrey700}`,
  width = 24,
  height = 16,
}) => {
  return (
    <Icon
      data-testid="order-placed-icon"
      viewBox="0 0 24 16"
      width={width}
      height={height}
    >
      <path
        d="M0 16H8V13.3333H0V16ZM0 0V2.66667H24V0H0ZM0 9.33333H16V6.66667H0V9.33333Z"
        fill={fillColor}
      />
    </Icon>
  );
};

export default OrderPlacedIcon;
